import { keepPreviousData, queryOptions } from "@tanstack/react-query"
import { z } from "zod"
import { PROJECT_STATUSES } from "@/features/project-status/core/projectStatus"
import { reportsQueryKeys } from "@/lib/queryKeys"
import {
  getMetersOverviewReport,
  type MetersOverviewParams,
} from "../../server/metersOverviewServer"

/**
 * URL search-param schema for the Meters Overview report. All keys are
 * optional; the component fills in defaults when reading.
 */
export const MetersOverviewSearchParams = z.object({
  status: z.enum(PROJECT_STATUSES).optional(),
  countryIds: z.array(z.string()).optional(),
  pageIndex: z.coerce.number().int().min(0).optional(),
  pageSize: z.coerce.number().int().min(1).max(200).optional(),
})

export type MetersOverviewSearchValues = z.infer<typeof MetersOverviewSearchParams>

export const METERS_OVERVIEW_DEFAULTS = {
  status: "approved" as const,
  pageIndex: 0,
  pageSize: 25,
}

export const applyMetersOverviewDefaults = (
  s: MetersOverviewSearchValues,
): MetersOverviewParams => ({
  status: s.status ?? METERS_OVERVIEW_DEFAULTS.status,
  countryIds: s.countryIds,
  pageIndex: s.pageIndex ?? METERS_OVERVIEW_DEFAULTS.pageIndex,
  pageSize: s.pageSize ?? METERS_OVERVIEW_DEFAULTS.pageSize,
})

export const metersOverviewQuery = (params: MetersOverviewParams) =>
  queryOptions({
    queryKey: reportsQueryKeys.metersOverview(params),
    queryFn: () => getMetersOverviewReport({ data: params }),
    placeholderData: keepPreviousData,
  })
